export const MESSAGES: Messages = {
  CREATE: {
    SUCCESS: {
      variant: "default",
      description:
        "Arquivo D-TEF processado com sucesso, você receberá um email quando a importação for concluída!",
      duration: 5000,
      closeOnClick: true,
    },
    ERROR: {
      variant: "destructive",
      description:
        "Arquivo inválido. Verifique o conteúdo do arquivo e tente novamente.",
      duration: 5000,
      closeOnClick: true,
    },
    INFO: {
      variant: "information",
      duration: 5000,
      closeOnClick: true,
      description:
        "Por favor, selecione o tipo de importação antes de escolher o arquivo.",
    },
    WARNING: {
      variant: "alert",
      duration: 5000,
      closeOnClick: true,
      description:
        "O arquivo selecionado não é válido para o tipo de importação escolhido.",
    },
  },
  UPDATE: {
    SUCCESS: {
      variant: "default",
      description: "Validação D-TEF atualizada com sucesso!",
      duration: 5000,
      closeOnClick: true,
    },
    ERROR: {
      variant: "destructive",
      description: "Erro ao atualizar validação D-TEF.",
      duration: 5000,
      closeOnClick: true,
    },
  },
  DISABLED: {
    SUCCESS: {
      variant: "default",
      description: "Operação realizada com sucesso na validação D-TEF!",
      duration: 5000,
      closeOnClick: true,
    },
    ERROR: {
      variant: "destructive",
      description: "Erro ao realizar a operação na validação D-TEF.",
      duration: 5000,
      closeOnClick: true,
    },
  },
};

export const MESSAGES_PIX: Messages = {
  CREATE: {
    SUCCESS: {
      variant: "default",
      description:
        "Arquivo PIX D-TEF processado com sucesso, você receberá um email quando a importação for concluída!",
      duration: 5000,
      closeOnClick: true,
    },
    ERROR: {
      variant: "destructive",
      description:
        "Arquivo PIX inválido. Verifique o conteúdo do arquivo e tente novamente.",
      duration: 5000,
      closeOnClick: true,
    },
    INFO: {
      variant: "information",
      duration: 5000,
      closeOnClick: true,
      description:
        "Por favor, selecione o tipo de importação antes de escolher o arquivo.",
    },
    WARNING: {
      variant: "alert",
      duration: 5000,
      closeOnClick: true,
      description:
        "O arquivo selecionado não é válido para o tipo de importação escolhido.",
    },
  },
};
